import React, { useEffect, useState, useCallback } from "react";
import ModalComponent from "../../../components/modals";
import LoadingFeedback, { useLoadingState } from "../../../components/loadingFeedback";
import {
  callApiAsync,
  getHistoryDataByServiceOrderList
} from "../../../services/apiService";
import { getOptionName, requestState } from "../../../constants/selectData";
import { icons } from "../../../constants";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { historyType, statesServiceOrderEnum } from "../../../constants/enums";
import PaginatedList from "../../../components/paginatedList";
import "./styles.css";
import { StyledTooltip } from "../../../components/toolltipComponent";

const HistoryModalUnique = ({ open, close, id }) => {
  const [loadingHistory, setLoadingHistory] = useLoadingState();
  const [historyData, setHistoryData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showCopiedToast, setShowCopiedToast] = useState(false);

  const urlApi = process.env.REACT_APP_API_URL;

  const formatDate = (dateString) => {
    return format(new Date(dateString), "d 'de' MMMM yyyy HH:mm", {
      locale: es
    });
  };

  const getHistory = useCallback(
    async (page = 1) => {
      await callApiAsync(
        () => getHistoryDataByServiceOrderList(id, page, 10),
        (data) => {
          setHistoryData(data.data);
          setTotalPages(data.totalPages);
        },
        setLoadingHistory
      );
    },
    [id, setLoadingHistory]
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getHistory(newPage);
  };

  const copyDataInClipBoard = async (data) => {
    try {
      await navigator.clipboard.writeText(data);
      setShowCopiedToast(true);
    } catch (err) {
      // fallback
      const textArea = document.createElement("textarea");
      textArea.value = data;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setShowCopiedToast(true);
      } catch (fallbackError) {
        console.error("Error al copiar con fallback:", fallbackError);
      }
      document.body.removeChild(textArea);
    }
  };

  useEffect(() => {
    if (open) {
      getHistory(currentPage);
    }
  }, [open, currentPage, getHistory]);

  const renderHistoryItem = (record) => {
    switch (record.history_type) {
      case historyType.createOrder:
        return (
          <div className="history-item history-new">
            <strong className="history-os">{record.serviceOrderName}</strong>
            <div className="ml-10 IHContainer datac-history j-space-between">
              <div className="VContainer">
                <div className="history-user">
                  <strong>{record.userName}</strong> creó la nueva orden de
                  Servicio
                </div>
              </div>
              {/* <div className="VContainer align-end">
                <span className="dateText-history">
                  {formatDate(record.creationDate)}
                </span>
                {record.comment == "" ? (
                  <></>
                ) : (
                  <StyledTooltip
                    title={
                      <div>
                        <p className="toolkit-title">Comentario:</p>
                        <p className="toolkit-content">{record.comment}</p>
                      </div>
                    }
                    followCursor
                  >
                    <div
                      className="comment-copy-button j-center align-center pointer ml-10"
                      onClick={() => {
                        copyDataInClipBoard(record.comment);
                      }}
                      style={{
                        width: "30px",
                        height: "30px",
                        backgroundColor: "white",
                        borderRadius: "4px",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)"
                      }}
                    >
                      <img
                        className="btn-icon"
                        src={icons.so_comment}
                        alt="Copiar comentario"
                        style={{ width: "16px", height: "16px" }}
                      />
                    </div>
                  </StyledTooltip>
                )}
              </div> */}
            </div>
          </div>
        );

      case historyType.changeStateOrder:
        const isTestingState =
          String(record.newState) === String(statesServiceOrderEnum.Testing);

        const isReturnState =
          String(record.newState) === String(statesServiceOrderEnum.Return);

        const isFinalState =
          String(record.newState) === String(statesServiceOrderEnum.Completed);

        return (
          <div className="history-item history-changeState">
            <strong className="history-os">{record.serviceOrderName}</strong>
            <div className="ml-10 IHContainer datac-history j-space-between">
              <div className="VContainer j-center">
                <div className="history-user">
                  <strong>{record.userName}</strong> ha actualizado el estado
                </div>
                <div className="history-status-container">
                  <span className="history-status">
                    {getOptionName(requestState, record.newState)}
                  </span>
                </div>
              </div>

              <div className="VContainer align-end">
                <span className="dateText-history">
                  {formatDate(record.creationDate)}
                </span>

                {isTestingState || isReturnState ? (
                  <div
                    className="comment-copy-button j-center align-center pointer ml-10"
                    onClick={() => {
                      const path = record.image_path;
                      const fileUrlExample = `${urlApi}/${path}`;
                      window.open(fileUrlExample, "_blank");
                    }}
                    style={{
                      width: "30px",
                      height: "30px",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)"
                    }}
                  >
                    <img
                      className="btn-icon"
                      src={icons.orangeFormGoogle}
                      alt={
                        isTestingState
                          ? "Ver archivo de prueba"
                          : "Ver archivo de retorno"
                      }
                      style={{ width: "16px", height: "16px" }}
                    />
                  </div>
                ) : record.comment == "" || isFinalState ? (
                  <></>
                ) : (
                  <StyledTooltip
                    title={
                      <div>
                        <p className="toolkit-title">Comentario:</p>
                        <p className="toolkit-content">{record.comment}</p>
                      </div>
                    }
                    followCursor
                  >
                    <div
                      className="comment-copy-button j-center align-center pointer ml-10"
                      onClick={() => {
                        copyDataInClipBoard(record.comment);
                      }}
                      style={{
                        width: "30px",
                        height: "30px",
                        backgroundColor: "white",
                        borderRadius: "4px",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)"
                      }}
                    >
                      <img
                        className="btn-icon"
                        src={icons.so_comment}
                        alt="Copiar comentario"
                        style={{ width: "16px", height: "16px" }}
                      />
                    </div>
                  </StyledTooltip>
                )}
              </div>
            </div>
          </div>
        );

      case historyType.changeEngineerOrder:
        return (
          <div className="history-item history-engineerChange">
            <strong className="history-os">{record.serviceOrderName}</strong>
            <div className="ml-10 IHContainer datac-history j-space-between">
              <div className="VContainer j-center">
                <div className="history-user">
                  <strong>{record.userName}</strong> cambió ingeniero a cargo:
                </div>
                <div className="history-status-container">
                  <span className="history-status">
                    {record.newEngineerName}
                  </span>
                </div>
              </div>
              <div className="VContainer align-end">
                <span className="dateText-history">
                  {formatDate(record.creationDate)}
                </span>
                {record.comment == "" ? (
                  <></>
                ) : (
                  <StyledTooltip
                    title={
                      <div>
                        <p className="toolkit-title">Comentario:</p>
                        <p className="toolkit-content">{record.comment}</p>
                      </div>
                    }
                    followCursor
                  >
                    <div
                      className="comment-copy-button j-center align-center pointer ml-10"
                      onClick={() => {
                        copyDataInClipBoard(record.comment);
                      }}
                      style={{
                        width: "30px",
                        height: "30px",
                        backgroundColor: "white",
                        borderRadius: "4px",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)"
                      }}
                    >
                      <img
                        className="btn-icon"
                        src={icons.so_comment}
                        alt="Copiar comentario"
                        style={{ width: "16px", height: "16px" }}
                      />
                    </div>
                  </StyledTooltip>
                )}
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="history-item">
            <div className="mr-20" style={{ minWidth: "55px" }}>
              <strong className="history-os">{record.serviceOrderName}</strong>
            </div>
            <div className="VContainer j-center">
              <div className="history-user">
                <strong>{record.userName}</strong> realizó una acción
                desconocida.
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <ModalComponent
      open={open}
      handleClose={close}
      title={"Historial"}
      width="600px"
      actions={<></>}
    >
      <LoadingFeedback loading={loadingHistory} rows={4}>
      {historyData.length === 0 ? (
        <p>No hay historial disponible</p>
      ) : (
        <div className="history-container">
          {historyData.map((record, index) => (
            <React.Fragment key={index}>
              {renderHistoryItem(record)}
            </React.Fragment>
          ))}
        </div>
      )}

      <PaginatedList
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
      </LoadingFeedback>
    </ModalComponent>
  );
};

export default HistoryModalUnique;
